import { createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from 'redux-devtools-extension'

import reducers from 'reducers'
import sagas from 'sagas'

const create = () => {
  // Grab the state from a global variable injected into the server-generated
  // HTML.
  const preloadedState = window.__PRELOADED_STATE__

  // Allow the passed state to be garbage-collected.
  delete window.__PRELOADED_STATE__

  const sagaMiddleware = createSagaMiddleware()

  const middleware = composeWithDevTools(applyMiddleware(sagaMiddleware))

  const store = createStore(reducers, preloadedState, middleware)

  sagas.forEach(saga => sagaMiddleware.run(saga))

  // Tell react-snap how to save Redux state
  window.snapSaveState = () => ({
    __PRELOADED_STATE__: store.getState(),
  })

  return store
}

export default create
